export { default as useCacheProductsSearchSuggestInputKeyboard } from './useCacheProductsSearchSuggestInputKeyboard';
